window.timberSlider = window.timberSlider || {};
/*
timberSlider.cacheSelectors = function () {
  timberSlider.cache = {
    // Home Page
    $slider: $('.flexslider')
  }
};

timberSlider.init = function () {
  timberSlider.cacheSelectors();
  timberSlider.sliders();
};

timberSlider.sliders = function () {
  var $slider = timberSlider.cache.$slider,
      sliderArgs = {
        animation: 'slide',
        animationSpeed: 500,
        pauseOnHover: true,
        keyboard: false,
        slideshow: true,
        slideshowSpeed: 3000,
        controlNav: true,
        smoothHeight: false
      };

  if ($slider.length) {

    if ($slider.find('li').length === 1) {
      sliderArgs.slideshow = false;
      sliderArgs.slideshowSpeed = 0;
      sliderArgs.controlNav = false;
      sliderArgs.directionNav = false;
    }

    $slider.flexslider(sliderArgs);
  }
};

// Initialize slider on docready
$(window).on('load', function() {
  timberSlider.init();
});

*/

$(document).ready(function() {
 
 
  $("#clients-carousel").owlCarousel({

    autoPlay: 3000, //Set AutoPlay to 3 seconds

    items : 5,
    iitemsDesktop: [1199, 5],
    itemsDesktopSmall: [980, 5],
    itemsTablet: [630, 2],
    itemsTabletSmall: false,
    itemsMobile: [479, 1],
    singleItem: false,
    animation: "slide"

  });

 
    var sidebar_count = $('.featured.sidebar li.item-row').length;    
    if(sidebar_count > 2 ) { $('.nav_sidebar').css('display','block');}
    else {$('.nav_sidebar').css('display','none');}
    var sidebar = $(".featured.sidebar");
    sidebar.owlCarousel({
      items: 1,
      itemsCustom: false,
      itemsDesktop: [1199, 1],
      itemsDesktopSmall: [980, 1],
      itemsTablet: [630, 1],
      itemsTabletSmall: false,
      itemsMobile: [479, 1],
      singleItem: false,
      itemsScaleUp: false,
      responsive: true,
      responsiveRefreshRate: 200,
      responsiveBaseWidth: window,
      autoPlay: false,
      stopOnHover: false,
      navigation: false,
      pagination:false
    });
    // Custom Navigation Events
    $(".nav_sidebar .next").click(function(){
      sidebar.trigger('owl.next');
    })
    $(".nav_sidebar .prev").click(function(){
      sidebar.trigger('owl.prev');
    }) 

    
    
    
    
 var blog_count = $('.home-blog.blog-section ul li.grid__item').length;    
    if(blog_count > 2 ) { $('.nav_blog').css('display','block');}
    else {$('.nav_blog').css('display','none');}
    var blog_cnt = $(".home-blog.blog-section ul");
    blog_cnt.owlCarousel({
      items: 1,
      itemsCustom: false,
      itemsDesktop: [1199, 1],
      itemsDesktopSmall: [980, 1],
      itemsTablet: [630, 1],
      itemsTabletSmall: false,
      itemsMobile: [479, 1],
      singleItem: false,
      itemsScaleUp: false,
      responsive: true,
      responsiveRefreshRate: 200,
      responsiveBaseWidth: window,
      autoPlay: false,
      stopOnHover: false,
      navigation: false,
      pagination:false
    });
    // Custom Navigation Events
    $(".nav_blog .next").click(function(){
      blog_cnt.trigger('owl.next');
    })
    $(".nav_blog .prev").click(function(){
      blog_cnt.trigger('owl.prev');
    }) 
  

  
  
  
  
 
});